/*
 * @Author: liyifan 
 * @Date: 2025-04-18 11:51:50 
 * @Last Modified by: liyifan
 * @Last Modified time: 2025-04-22 15:56:04
 * @Description: 对话框滚动动画
 */
import './index.less'

// 滚动动画类，用于实现对话框的滚动效果
export default class ScrollAnimation {
    constructor() {
        // 获取所有标题元素
        this.titles = gsap.utils.toArray(".scroll-animate .title");
        // 获取容器元素
        this.container = document.querySelector(".scroll-animate .container");
        // 获取底部元素
        this.bottomElement = document.querySelector(".scroll-animate .bottom");
        // 当前显示的标题索引
        this.currentIndex = 0;
        // 上一次的滚动进度
        this.lastProgress = 0;
        // 初始化动画
        this.init();
        // 创建滚动触发器
        this.createScrollTrigger();
    }

    // 初始化方法，设置标题的初始状态
    init() {
        this.titles.forEach((title, i) => {
            gsap.set(title, {
                y: i === 0 ? 0 : 100,  // 垂直位置
                x: 0,  // 水平位置
                scale: i === 0 ? 1 : i === 1 ? 0.7 : 0.5,  // 缩放比例
                opacity: i === 0 ? 1 : i === 1 ? 0.3 : 0,  // 透明度
                zIndex: i === 0 ? 3 : i === 1 ? 2 : 1,  // 层级
            });
        });
        // 启动文本动画
        this.animateText()
    }

    // 文本动画方法，使用IntersectionObserver实现渐现效果
    animateText() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('jky-up-animation');
                } else {
                    entry.target.classList.remove('jky-up-animation');
                }
            });
        });

        const slideups = document.querySelectorAll('.jky-up')
        if (slideups && slideups.length) {
            slideups.forEach(item => {
                observer.observe(item);
            })
        }
    }

    // 标题动画方法，根据目标索引更新标题状态
    animateTitles(targetIndex) {
        if (targetIndex !== this.currentIndex && targetIndex >= 0 && targetIndex < this.titles.length) {
            this.currentIndex = targetIndex;
            const titlesTl = gsap.timeline();
            this.titles.forEach((title, i) => {
                titlesTl.to(title, {
                    y: this.currentIndex === i ? 0 : i < this.currentIndex ? -100 : 100,
                    scale: this.currentIndex === i ? 1 : 0.7,
                    opacity: i === this.currentIndex ? 1 : Math.abs(i - this.currentIndex) === 1 ? 0.3 : 0,
                    zIndex: i === this.currentIndex ? 3 : 2,
                    duration: 1,
                    ease: "power2.inOut",
                }, '<')
            });
        }
    }

    // 底部元素动画方法，根据滚动方向显示或隐藏底部元素
    animateBottom(scrollingForward, progress) {
        if (!scrollingForward) {
            if (progress >= 0.9) {
                gsap.to(this.bottomElement, {
                    bottom: '-100vh',
                    opacity: 0,
                    duration: 1,
                    ease: "power2.inOut"
                });
            }
        } else {
            if (progress >= 0.9) {
                gsap.to(this.bottomElement, {
                    bottom: 0,
                    opacity: 1,
                    duration: 1,
                    ease: "power2.out"
                });
            }
        }
    }

    // 创建滚动触发器，监听滚动事件并触发相应动画
    createScrollTrigger() {
        gsap.timeline({
            scrollTrigger: {
                trigger: this.container,
                start: "top top",
                end: "+=2000",
                scrub: 1,
                pin: true,
                onUpdate: (self) => {
                    const progress = self.progress;
                    const scrollingForward = progress > this.lastProgress;
                    this.lastProgress = progress;

                    if (progress <= 0.8) {
                        let targetIndex = Math.round((progress / 0.8) * (this.titles.length - 1));
                        this.animateTitles(targetIndex);
                    } else {
                        this.animateBottom(scrollingForward, progress);
                    }
                }
            },
        });
    }
}


